<template>
  <div>
    <el-card>
      <!-- 功能 -->
      <div class="header-menu">
        <!-- class="demo-form-inline" -->
        <el-form :inline="true" label-width="100px">
          <el-form-item label="学生姓名">
            <el-input placeholder="搜索学生" clearable v-model="fromState.realname"></el-input>
          </el-form-item>
          <el-form-item label="微信号">
            <el-input placeholder="请输入微信号" clearable v-model="fromState.wechat"></el-input>
          </el-form-item>
          <el-form-item label="家长电话">
            <el-input placeholder="请输入家长电话" clearable v-model="fromState.telephone"></el-input>
          </el-form-item>
          <el-form-item label="年级">
            <el-cascader clearable style="width: 100%;" v-model="fromState.gradeList" :options="gradeList"
              :props="props"></el-cascader>
          </el-form-item>
          <el-form-item label="家庭住址">
            <el-input placeholder="请输入家庭住址" v-model="fromState.address" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item label="跟进老师">
            <el-input placeholder="请输入跟进老师" v-model="fromState.progressTeacherName" clearable></el-input>
          </el-form-item> -->
          <el-form-item label="销售">
            <!-- <el-input placeholder="请输入销售" v-model="fromState.saleName" clearable></el-input> -->
            <el-select
              placeholder="请选择销售"
              v-model="fromState.saleName"
              style="width: 100%"
              clearable
              filterable :filter-method="handleChangeName">
              <el-option
                v-for="item in teachingMethodsArr"
                :key="item.saleId"
                :value="item.saleId"
                :label="item.saleName">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="来源负责人">
            <!-- <el-select filterable  clearable class="select" v-model="fromState.sourcepeopleId" placeholder="请选择来源负责人"> -->
              <!-- <el-option v-for="item in sourcepeopleList" :key="item.id" :value="item.id" :label="item.value">
              </el-option> -->
              <!-- <el-option v-for="item in sourcepeopleList" :key="item.sourcepeopleId" :label="item.sourcepeopleName"  :value="item.sourcepeopleId"></el-option> -->
            <!-- </el-select> -->
            <selectcomtent  :objUrl="{  tiile:'来源负责人', keys:'fromState.sourcepeopleId', selectList:'/customerinformation/sourcepeoplelist', }" @handleChangeSelect="handleChangeSelect"></selectcomtent>
          </el-form-item>
          <el-form-item label="学生类型">
            <el-select class="select" filterable  clearable v-model="fromState.classType" placeholder="请选择" style="width:100%;">
              <el-option v-for="item in classTypes" :key="item.value" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学生状态" v-if="currentPath !== '/currentStudents'">
            <el-select class="select" filterable  clearable v-model="fromState.state" placeholder="请选择" style="width:100%;">
              <el-option v-for="item in classTypes_s" :key="item.value" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="跟进助理">
            <el-select class="select" filterable  clearable v-model="fromState.assistantId" placeholder="请选择跟进助理" style="width:100%;">
              <el-option v-for="item in Progressteacher" :key="item.id" :value="item.id" :label="item.realname">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所在地域:">
            <el-select v-model="fromState.regionName" clearable filterable placeholder="请选择所在地域">
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
              :value="item.dictType"></el-option>
            </el-select>
          </el-form-item>

          

          <el-form-item label="渠道">
            <el-select clearable id="teacher" filterable   class="select" v-model="channelType" placeholder="请选择渠道">
              <el-option v-for="teacher in DealTypeListt" :key="teacher.value" :value="teacher.value" :label="teacher.label">
              </el-option>
            </el-select>
          </el-form-item>


          <el-form-item label="诊断师">
            <el-select class="select" filterable  clearable v-model="fromState.diagnoseTeacherId" placeholder="请选择诊断师" style="width:100%;">
              <el-option v-for="item in Progressteacher1111" :key="item.teacherId" :value="item.teacherId" :label="item.teacherName">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="规划师">
            <el-select class="select" filterable  clearable v-model="fromState.projectTeacherId" placeholder="请选择规划师" style="width:100%;">
              <el-option v-for="item in Progressteacher2222" :key="item.teacherId" :value="item.teacherId" :label="item.teacherName">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="创建时间：" >
            <el-date-picker
              v-model="createTimeStart"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择开始时间"
              style="width: 200px;"
            ></el-date-picker>
            <span style="margin: 0px 10px;">至</span>
            <el-date-picker
              v-model="createTimeEnd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择结束时间"
              style="width: 200px;"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="流失时间：" >
            <el-date-picker
              v-model="lapsedDateStart"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择开始时间"
              style="width: 200px;"
            ></el-date-picker>
            <span style="margin: 0px 10px;">至</span>
            <el-date-picker
              v-model="lapsedDateEnd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择结束时间"
              style="width: 200px;"
            ></el-date-picker>
          </el-form-item>

          <el-row>
            <!-- <el-col :span="18"></el-col> -->
            <el-col :span="12" :push="12" style="text-align: right; margin-bottom: 24px;">
              <!-- <el-button @click="handleView" class="btns" size="small" icon="el-icon-view">查看沟通详情</el-button> -->
              <el-button type="primary" @click="handleDownload1" class="btns" size="small" icon="el-icon-download">导出老师学生</el-button>
              <el-button type="primary" @click="handleDownload" class="btns" size="small" icon="el-icon-download">导出学生</el-button>
              <el-button @click="handleClearList" class="btns" size="small" icon="el-icon-close">清除</el-button>
              <el-button type="primary" icon="el-icon-search" @click="searchStudent" size="small" class="btns" >搜索</el-button>
              <!-- <el-button v-if="currentPath !== '/currentStudents'" type="primary" @click="addStudent" class="btns" size="small" icon="el-icon-plus">添加学生</el-button> -->
              <!-- <el-button type="primary" @click="count" icon="el-icon-thumb" size="small" class="btns">一键计算</el-button> -->
            </el-col>
          </el-row>


        </el-form>



        <!-- <el-select v-model="value1" placeholder="年级" @change="queryClass" @clear="gradeListener" clearable>
          <el-option v-for="item in grade" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select v-model="value2" placeholder="班级" @change="queryStudentByClass" @clear="classListener" clearable>
          <el-option
            v-for="item in classNo"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select> -->
      </div>
      <!-- 查询学生列表-->
      <el-table :data="studentData" :stripe="true" :highlight-current-row="true"  height="700" :header-cell-style="{'text-align':'center', background: '#fafafa', }" :cell-style="{'text-align':'center'}" >
        <!-- <el-table-column label="序号" type="selection"></el-table-column> -->
        <el-table-column prop="realname" label="姓名" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <!-- <router-link :to="'/student-detail/' + scope.row.id" class="name-link" @click="highlightRow(scope.$index)">
              {{ scope.row.realname }}
            </router-link> -->
            <span style="color: #2784e5;" @click="highlightRow(scope.row.id,scope.$index)">  {{ scope.row.realname }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sex" label="性别" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.sex === 1">男</span>
            <span v-else-if="scope.row.sex === 2">女</span>
          </template>
        </el-table-column>
        <el-table-column prop="regionName" label="所在地域" width="100" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column prop="wechat" label="微信" width="100"></el-table-column> -->
        <el-table-column prop="grade" label="年级" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column prop="assistantName" label="跟进助理" width="100" show-overflow-tooltip>
        </el-table-column>
        <!-- <el-table-column prop="telephone" label="家长电话"></el-table-column> -->
        <el-table-column prop="address" label="家庭住址" width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="saleName" label="销售" width="150" show-overflow-tooltip> </el-table-column>
        <el-table-column label="学生类型" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.classType === 1">规划</span>
            <span v-if="scope.row.classType === 2">线下</span>
            <span v-if="scope.row.classType === 3">纯补课</span>
          </template>
        </el-table-column>
        <el-table-column label="学生状态" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.state === 1">在读</span>
            <span v-if="scope.row.state === 2">结业</span>
            <span v-if="scope.row.state === 3">停课</span>
            <span v-if="scope.row.state === 4">流失</span>
            <span v-if="scope.row.state === 5">课前咨询</span>
          </template>
        </el-table-column>

        <el-table-column label="诊断师" prop="diagnoseTeacherName"  show-overflow-tooltip> </el-table-column>
        <el-table-column label="渠道" prop="channelType"  show-overflow-tooltip>
             <template slot-scope="scope">
                <span v-if="scope.row.channelType === 1 || scope.row.channelType === '1'">线上</span>
                <span v-if="scope.row.channelType === 2 || scope.row.channelType === '2'">线下</span>
                <span v-if="scope.row.channelType === 3 || scope.row.channelType === '3'">转介绍</span>
             </template>
        </el-table-column>
        <el-table-column label="规划师" prop="projectTeacherName"  show-overflow-tooltip> </el-table-column>

        <el-table-column label="跟进老师" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-for="(item, index)  in scope.row.progressTeacherName" :key="index">
              {{ item }} {{ (index == scope.row.progressTeacherName.length - 1) ? "" : "/" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="来源负责人" prop="sourcepeople_name" show-overflow-tooltip width="180"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="lapsedDate" label="流失时间" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="editById(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 弹出表单编辑学生 -->
      <el-dialog id="bb" title="编辑学生" :visible.sync="visibleForm" :close-on-click-modal ='false'  @close="closeEditDialog" >
        <el-form ref="" label-position="left" label-width="80px" :rules="rules" :model="editFormData">
          <el-form-item label="姓名" prop="realname">
            <el-input v-model="editFormData.realname" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-radio-group class="sex" style="margin-left: -75%;" v-model="editFormData.sex">
              <el-radio label="1">男</el-radio>
              <el-radio label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="微信">
            <el-input v-model="editFormData.wechat" autocomplete="off"></el-input>
          </el-form-item> -->

          <!-- <el-form-item label="所在地域">
            <el-select v-model="editFormData.regionName" clearable filterable placeholder="请选择所在地域" style="width:100%;" >
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
              :value="item.dictType"></el-option>
            </el-select>
          </el-form-item> -->

          
           <!-- <el-form-item label="所在区域" v-if="regionName">
            <el-select v-model="districtId" clearable filterable placeholder="请选择所在地域" style="width:100%;">
              <el-option v-for="item in optionsListtt" :key="item.id" :label="item.dictValue"
              :value="item.dictType"></el-option>
            </el-select>
          </el-form-item> -->

     
          <el-form-item label="家庭住址">
            <el-row>
              <el-col :span="4">
                <el-select v-model="regionName" clearable filterable placeholder="请选择所在地域" style="width:100%;"   @change="handleClear">
                  <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue" :value="item.dictType"></el-option>
                </el-select>
              </el-col>
              <el-col :span="20">
                <el-autocomplete
                  style="width:100%;" 
                  v-model="newaddress"
                  :fetch-suggestions="querySearchAsync"
                  placeholder="请输入上课地点，例如：小区楼号，大厦名称"
                  clearable
                  @clear="handleautocompleteClear"
                  @select="handleSelect">
                    <template slot-scope="{ item }">
                      <span style="float: left">{{ item.value }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ item.address }}</span>
                      <i style="float: right; margin-top: 10px;  margin-right: 5px;" class="el-icon-location-information"></i>
                    </template>
                </el-autocomplete>
              </el-col>
            </el-row>
          </el-form-item>

          <el-form-item label="详细地址">
            <el-input v-model="detailedAddress" placeholder="请输入单元、楼层、门牌号"></el-input>
          </el-form-item>

          <el-form-item label="备注">
            <el-input v-model="remarks" type="textarea" :autosize="{ minRows: 6, maxRows: 6 }" placeholder="除详细地址外，需要同步给老师的信息"></el-input>
          </el-form-item>


          <el-form-item label="备用地址">
            <div style="width: 100%;text-align: start; display: flex; padding-top: 10px;">
              <div style="font-size: 20px;height: 20px; width: 20px;border: 1px solid #fff;" @click="handleAdd" class="el-icon-circle-plus-outline" ></div>
              <div style="font-size: 20px;height: 20px; width: 20px;border: 1px solid #fff;margin-left: 10px;" @click="handleRemove" class="el-icon-remove-outline" ></div>
            </div>
          </el-form-item>

          <el-form-item label="" v-if="ListDataLngLat.length > 0">
              <div v-for="(rowItme,rowIndex) in ListDataLngLat" :key="rowIndex" style="margin-bottom: 40px; margin-top: 10px;">
                <el-form-item label="家庭住址" prop="regionName" style="margin-bottom: 10px;">
                  <el-row>
                    <el-col :span="4">
                      <el-select v-model="rowItme.regionName" clearable filterable placeholder="请选择所在地域" style="width:100%;"  @change="handleClears(rowItme,rowIndex)">
                        <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue" :value="item.dictType"></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="20">
                      <el-autocomplete
                        style="width:100%;" 
                        v-model="rowItme.newaddress"
                        :fetch-suggestions="querySearchAsyncs"
                        placeholder="请输入上课地点，例如：小区楼号，大厦名称"
                        clearable
                        @clear="handleautocompleteClears(rowItme,rowIndex)"
                        @select="handleSelects(rowItme,$event)">
                          <template slot-scope="{ item }">
                            <span style="float: left">{{ item.value }}</span>
                            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.address }}</span>
                            <i style="float: right; margin-top: 10px;  margin-right: 5px;" class="el-icon-location-information"></i>
                          </template>
                      </el-autocomplete>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="详细地址" style="margin-bottom: 10px;">
                  <el-input v-model="rowItme.detailedAddress" placeholder="请输入单元、楼层、门牌号"></el-input>
                </el-form-item>
                <el-form-item label="备注" style="margin-bottom: 10px;">
                  <el-input v-model="rowItme.remarks" type="textarea"  :autosize="{ minRows: 6, maxRows: 6 }" placeholder="除详细地址外，需要同步给老师的信息"></el-input>
                </el-form-item>
              </div>
          </el-form-item>





          <el-form-item label="年级" prop="grades">
            <!-- <el-input v-model="editFormData.grade" autocomplete="off"></el-input> -->
            <el-cascader clearable style="width: 100%;" v-model="editFormData.grades" :options="gradeList"
              :props="props"></el-cascader>
          </el-form-item>
          <!-- <el-form-item label="家长电话">
            <el-input v-model="editFormData.telephone" autocomplete="off"></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="家庭住址">
            <el-input v-model="editFormData.address" autocomplete="off"></el-input>
          </el-form-item> -->

          <el-form-item label="销售" prop="saleId" v-if="editFormData.classType != 2">
            <el-select class="select" filterable clearable v-model="editFormData.saleId" placeholder="请选择销售" style="width:100%;">
              <el-option v-for="source in teachingMethodsArr" :key="source.saleId" :value="source.saleId" :label="source.label">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="跟进助理">
            <el-select class="select"  filterable clearable v-model="editFormData.assistantId" placeholder="请选择跟进助理"
              style="width:100%;">
              <el-option v-for="source in Progressteacher" :key="source.id" :value="source.id" :label="source.realname">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="诊断师">
            <el-select class="select"  filterable clearable v-model="editFormData.diagnoseTeacherId" placeholder="请选择诊断师"
              style="width:100%;">
              <el-option v-for="source in Progressteacher1111" :key="source.teacherId" :value="source.teacherId" :label="source.teacherName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规划师" v-if="editFormData.classType != 2">
            <el-select class="select"  filterable clearable v-model="editFormData.projectTeacherId" placeholder="请选择规划师"
              style="width:100%;">
              <el-option v-for="source in Progressteacher2222" :key="source.teacherId" :value="source.teacherId" :label="source.teacherName">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="渠道">
            <el-select clearable id="teacher" filterable  style="width:100%;"  class="select" v-model="editFormData.channelType" placeholder="请选择渠道">
              <el-option v-for="teacher in DealTypeListt" :key="teacher.value" :value="teacher.value" :label="teacher.label">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="来源">
            <!-- <el-select class="select" filterable  clearable allow-create default-first-option v-model="editFormData.sourcepeopleId"
              placeholder="请选择来源负责人" style="width:100%;">
              <el-option v-for="source in sourcesPeople" :key="source.sourcepeopleId" :value="source.sourcepeopleId"
                :label="source.sourcepeopleName">
              </el-option>
            </el-select> -->
            <selectcomtent  style="width: 100%;" width="100%"  :values="editFormData.sourcepeopleId" :objUrl="{  tiile:'来源',  selectList:'/customerinformation/sourcelist', keys:'editFormData.sourcepeopleId', }" @handleChangeSelect="handleChangeSelect"></selectcomtent>
          </el-form-item>
          <el-form-item label="跟进老师">
            <el-select class="select" multiple filterable clearable v-model="editFormData.progressTeacherIds" placeholder="请选择跟进老师"
              style="width:100%;">
              <el-option v-for="source in Progressteacher1" :key="source.id" :value="source.id" :label="source.realname">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学生类型" prop="classType">
            <el-select class="select" filterable  clearable v-model="editFormData.classType" placeholder="请选择" style="width:100%;">
              <el-option v-for="item in classTypes" :key="item.value" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="所在地域:">
            <el-select v-model="regionName" clearable filterable placeholder="请选择所在地域" style="width:100%;">
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
              :value="item.dictType"></el-option>
            </el-select>
          </el-form-item> -->


          <el-form-item label="学生状态">
            <el-select class="select" filterable  clearable v-model="editFormData.state" placeholder="请选择" style="width:100%;">
              <el-option v-for="item in classTypes_s" :key="item.value" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="是否有效" v-if="editFormData.state === 4">
            <div style="display: flex; margin-left: 18px;margin-top: 13px;">
              <el-radio v-model="isLose" :label="0" :disabled="adminType === 2" >是</el-radio>
              <el-radio v-model="isLose" :label="1" :disabled="adminType === 2" >否</el-radio>
            </div>
          </el-form-item>

          <el-form-item label="预存课时">
            <el-input-number style="display: flex;width: 100%;" v-model="prestoreHoursNum"  :min="0" :max="999" ></el-input-number>
          </el-form-item>

          <el-form-item label="消除课时">
            <el-input-number :disabled="showEiet" style="display: flex;width: 100%;" v-model="eliminateHoursNum"  :min="0" :max="999" ></el-input-number>
          </el-form-item>
          <el-form-item label="所欠课时">
            <el-input-number :disabled="showEiet" style="display: flex;width: 100%;" v-model="arrearsHoursNum"  :min="0" :max="999" ></el-input-number>
          </el-form-item>
          <!-- <el-form-item label="老师">
            <el-input
              placeholder="搜索老师"
              v-model="searchTeachers"
              @keyup.enter.native="handleSearch"
              clearable
            ></el-input>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancelUpd">取 消</el-button>
          <el-button type="primary" @click="commit()">提 交</el-button>
        </div>
      </el-dialog>

      <!-- 弹出添加学生 -->
      <edit-students ref="editStudents" @refresh="refresh"></edit-students>
      <!-- 上一页，当前页，下一页 -->
      <!-- <div class="footer-button" v-if="pages < 1">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="fromState.pageNum" :page-size="fromState.pageSize" layout="total, prev, pager, next"
          :total="total"></el-pagination>
      </div> -->

      <div class="footer-button111" >
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :key="pageNumsss"
          :current-page="pageNumsss" :page-size="fromState.pageSize" layout="total, prev, pager, next"
          :total="total"  @update:current-page="updatePageNumsss"></el-pagination>
      </div>


    </el-card>

    <el-dialog append-to-body title="查看沟通详情" :visible.sync="showView" :width="'60%'">

      <el-input v-model="input1" @input="handleInput"  placeholder="请输入学生姓名"></el-input>

      <el-table :data="tableData" border style="width: 100%;margin-top: 20px;" :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" >
                <el-table-column prop="studentName" label="学生姓名" show-overflow-tooltip></el-table-column>
                <el-table-column prop="count" label="沟通次数" show-overflow-tooltip></el-table-column>
                <el-table-column label="沟通详情" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span @click="handleClickView(scope.row)" style="color:#428BCA;">详情</span>
                  </template>
                </el-table-column>
        </el-table>

      <div class="footer-button" style="margin-top: 15px; text-align: center;">
        <el-pagination @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
          :current-page.sync="pageNums" :page-size="pageSizes" layout="total, prev, pager, next"
          :total="totals"></el-pagination>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showView = false" size="small">关闭</el-button>
      </div>
    </el-dialog>



    <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" title="导出老师学生"  :visible="show_view" :before-close="isnewModesCustomerFundingDetailscloseEditDialogs" width="60%">

        <el-form >

          <el-form-item label="学生类型:" label-width="88px">
            <el-select v-model="input1" filterable  clearable  placeholder="请选择学生类型" style="width: 34%;"  >
              <el-option v-for="item in classTypes" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="学生状态:" label-width="88px">
            <el-select v-model="input2" filterable clearable placeholder="请选择学生状态" style="width: 34%;" >
              <el-option v-for="item in classTypes_s" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="年级:" label-width="88px">
            <el-cascader clearable style="width: 34%;" v-model="input3" :options="gradeList"  :props="props"></el-cascader>
          </el-form-item>
         
        </el-form>

      <div  class="dialog-footer" style="text-align: end;">
        <div style="text-align: end;">
          <el-button size="small" @click="isnewModesCustomerFundingDetailscloseEditDialogs">关闭</el-button>
          <el-button size="small" type="primary"  :loading="show_loading" @click="isnewModesCustomerFundingDetailsSibutleForm">导出</el-button>
        </div>
      </div>
    </el-dialog>



  </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import EditStudents from "./EditStudents.vue";
import { aW } from "@fullcalendar/core/internal-common";
import selectcomtent from "../manager/selectcomtent.vue";

export default {
  name: "StudentList",
  components: { EditStudents,selectcomtent },
  data () {
    return {

      show_view: false,
      show_loading: false,

      optionsListss: [],
      input1: "",
      input2: "",
      input3: [],

      lapsedDateEnd:'',
      lapsedDateStart:'',

      isLose: 0, // 是否有效  1否 0是

      rules: {
        realname: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" }
        ],
        sex: [
          { required: true, message: "请选择性别", trigger: "change" }
        ],
        grades: [
          { required: true, message: "请选择年级", trigger: "change" }
        ],
        saleId: [
          { required: true, message: "请选择销售", trigger: "change" }
        ],
        classType: [
          { required: true, message: "请选择学生类型", trigger: "change" }
        ],
        
      },

      pageNumsss:1,

      showView:false,
      input1:"",
      tableData:[ ],


      createTimeStart:"",
      createTimeEnd:"",
      optionsListtt:[],

      regionName:"北京",
      // optionsListt:[
      //   {name:"北京", id:'北京' },
      //   {name:"深圳", id:'深圳' },
      // ],
      showEiet:false,
      prestoreHoursNum: 0,
      eliminateHoursNum: 0,
      arrearsHoursNum: 0,
      gradeList: [],
      props: {
        label: "gradeName",
        children: "children",
        value: "id"
      },
      studentData: [],
      classTypes: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],
      classTypes_s: [{ value: 1, label: '在读' }, { value: 2, label: '结业' }, { value: 3, label: '停课' },{ value: 4, label: '流失' },{ value: 5, label: '课前咨询' }],
      searchTeachers: "",
      editFormData: {
        channelType: "",
        id: "",
        assistantId:'',
        assistantId1:'',
        assistantId2:'',
        classType: "",
        studentNo: "",
        username: "",
        realname: "",
        grades: [],
        classNo: "",
        telephone: "",
        genjinlaoshi: "",
        email: "",
        address: "",
        age: "",
        sex: "",
        sourceName: "",
        wechat: "",
        sourcepeopleId: "",
        saleId: "",
        genjinlaoshi: "",
        state: "",
        progressTeacherName: [],
        progressTeacherIds: [],
        createTime: null,
        regionName:'北京',
        districtId:'',
        diagnoseTeacherId: '',
        projectTeacherId: '',
      },

      // progressTeacherName: [],
      Progressteacher: [],
      Progressteacher1: [],
      teacherData: [],
      sourcesPeople: [],
      salesName: [],
      keyword: "",
      fromState: {
        state:"",
        classType: '',
        realname: "",
        wechat: "",
        gradeList: [],
        telephone: "",
        address: "",
        progressTeacherName: "",
        saleName: "",
        sourcepeopleId: "",
        pageSize: 10,
        pageNum: 1,
        assistantId:'',
        regionName: '',
        diagnoseTeacherId: '',
        projectTeacherId: '',
      },
      page: 1,
      pageSize: 10,
      total: 0,
      value1: "", // 年级
      value2: "", // 班级
      grade: [
        {
          value: "01",
          label: "高一"
        },
        {
          value: "02",
          label: "高二"
        },
        {
          value: "03",
          label: "高三"
        }
      ],
      sourcepeopleList: [
        // {
        //   value: "bin",
        //   id: 1,
        // },
        // {
        //   value: "小慈",
        //   id: 2,
        // },
        // {
        //   value: "兰",
        //   id: 3,
        // },
        // {
        //   value: "小五",
        //   id: 4,
        // },
        // {
        //   value: "铁甲小宝",
        //   id: 5,
        // },
      ],
      classNo: [
        {
          value: "",
          label: ""
        }
      ],
      currentPath: this.$route.path ,
      visibleForm: false,
      visibleDialog: false, //添加学生
      editFormRules: {
        username: [{ required: true, message: "请输入昵称", trigger: "blur" }],
        realname: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        sex: [{ required: true, message: "请输入性别", trigger: "blur" }],
        grade: [{ required: true, message: "请输入年级", trigger: "blur" }],
        classNo: [{ required: true, message: "请输入班级", trigger: "blur" }],
        telephone: [
          { required: true, message: "请输入联系电话", trigger: "blur" }
        ],
        email: [{ required: true, message: "请输入邮件", trigger: "blur" }],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        age: [{ required: true, message: "请输入年龄", trigger: "blur" }],
        wechat: [{ required: true, message: "请输入微信", trigger: "blur" }]
      },

      pageNums:1,
      pageSizes:10,
      totals:0,

      optionsListt:[
        {dictValue:"北京", dictType:1 },
        {dictValue:"深圳", dictType:2 },
      ],

      pages:2,

      remarks: '',
      detailedAddress: '',
      districtId: '',
      newaddress: '',

      infoObj: { },

      Progressteacher1111:[],
      Progressteacher2222:[],
      teachingMethodsArr: [],

      ListDataLngLat:[],

      xxxxx: 0,
      DealTypeListt: [
        {
          value: 1,
          label: "线上",
        },
        {
          value: 2,
          label: "线下",
        },
        {
          value: 3,
          label: "转介绍",
        },
      
      ],
      channelType:"",

      adminType:'',

      isclassType:'',

    };
  },

  watch:{
      '$route.path':function(newVal,oldVal){
            this.currentPath = newVal;
            this.getallStudentList()
        }
  },
  computed: {
    currentPage: {
      get() {
        return this.pageNumsss;
      },
      set(newValue) {

        this.pageNumsss = newValue;
      }
    }
  },

  created () {
    // this.getallStudentList()
    // this.allStudent();
    // this.getDataSoursePeople();
    this.getTeacher()
    this.teacherSale()
    this.getGrade()
  },

   mounted () {
    let admin = JSON.parse(localStorage.getItem('admin'))
    this.adminType = admin.isRoot || ''


    // axios.get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then((response) => {
    //    this.sourcepeopleList = response.data.data.list;
    // }).catch((error) => {
    //   console.error(error);
    // });

    axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
      this.optionsListt = res.data.data
    })

    this.Progressteacher1111 = JSON.parse(sessionStorage.getItem('diagnoseTeacherFindList'))
    this.Progressteacher2222 = JSON.parse(sessionStorage.getItem('projectTeacherFindList'))

    // axios.get(`${apiBaseUrl}/teacher/teacherSale`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ this.teachingMethodsArr = res.data.data})

    this.teachingMethodsArr = JSON.parse(sessionStorage.getItem('customersaleObj1'))

    let pages = window.sessionStorage.getItem('pages')
    this.fromState.pageNum = Number(pages)

    this.pages = Number(pages)
    this.pageNumsss = Number(pages)


    this.$set(this.fromState,'pageNum',Number(pages))

    this.getallStudentList()


  },
  methods: {
    handleChangeSelect (keys,value) {
       this[keys] = value
    },

    isnewModesCustomerFundingDetailsSibutleForm() {
      this.show_loading = true
      const params = { classType: this.input1,  state: this.input2,  grades: this.input3,};

      axios.post(`${apiBaseUrl}/wx/exportTeacherStudent`,params,{ responseType: "blob",headers:{'authorization': sessionStorage.getItem('tokenInfo') } } ).then((response) => {
        const blob = new Blob([response.data], {   type: "application/vnd.ms-excel",}); 
        const downloadLink = document.createElement("a"); // 创建一个下载链接
        downloadLink.href = URL.createObjectURL(blob); // 设置下载链接的URL为Blob对象的URL
        downloadLink.download = "导出老师学生.xlsx"; // 设置下载文件的文件名
        downloadLink.click(); // 触发下载
        this.input1 = ""
        this.input2 = ""
        this.input3 = []
        this.show_view = false
        this.show_loading = false
      }).catch((error) => {
         this.show_loading = false
         this.$message.error(error)
      });
    },

    isnewModesCustomerFundingDetailscloseEditDialogs() {
      this.input1 = ""
      this.input2 = ""
      this.input3 = []
      this.show_view = false
    },

    handleChangeName(value) {
      if (value) {
        axios.post(`${apiBaseUrl}/saleWeight/getSaleList`, { saleName: value },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
          if (res.data.code == 200) {
            let datas = res.data.data.map(fore => {
                fore.id = fore.telephone
                fore.saleId = fore.saleId
                fore.label = fore.saleName 
                return fore
            })
            this.teachingMethodsArr = datas
          }else{
            this.teachingMethodsArr = JSON.parse(sessionStorage.getItem('customersaleObj1'))
          }
        })
      } else {
        this.teachingMethodsArr = JSON.parse(sessionStorage.getItem('customersaleObj1'))
      }
    },

    handleautocompleteClears(item,index) {
      console.log('handleautocompleteClears:', item,index);
      item.latitude = ''
      item.precisionLng = ''
      item.city = ''
      item.remarks = ''
      item.detailedAddress = ''
      item.newaddress = ''
      item.precisionLng = ''
      item.city = ''
      item.latitude = ''
      item.value = ''
      item.district = ''
      item.addressTitleName = ''
      item.addressFollow = ''
      item.districtName = ''
      item.address = ''
    },

    handleSelects(item,event) {
      console.log('用户选择了handleSelects:', item,event);
      item.latitude = event.latitude
      item.precisionLng = event.precisionLng
      item.city = event.city
      item.latitude = event.latitude
      item.precisionLng = event.precisionLng
      item.city = event.city
      item.newaddress = event.value
      item.precisionLng = event.precisionLng 
      item.city = event.city
      item.latitude = event.latitude
      item.value = event.value
      item.district = event.district
      item.addressTitleName = event.addressTitleName
      item.addressFollow = event.addressFollow
      item.districtName = event.districtName
      item.address = event.value
      
    },

    async querySearchAsyncs(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }

      // 模拟调用后端接口获取数据
      const results = await this.fetchAddressesFromBackends(queryString);

      // 调用回调函数，传递搜索结果
      cb(results);
    },

    // 模拟后端接口请求
    fetchAddressesFromBackends(query) {
       return new Promise((resolve, reject) => {
            let dateObj = {
              regionName: this.xxxxx === 1 ? '北京' : this.xxxxx === 2 ? '深圳' : this.xxxxx === 3 ? '上海' : this.xxxxx === 4 ? '广州' : '',
              keyword: query
            }
            axios.post(`${apiBaseUrl}/student/getSiteInfoList`, dateObj,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
              if (res.data.code === 200) {
                console.log(res.data.data, '获取地址列表')
                resolve(res.data.data.map(item => ({
                      value: item.addressTitleName,
                      city: item.districtName,
                      district: item.addressFollow,
                      addressTitleName: item.addressTitleName,
                      addressFollow: item.addressFollow,
                      districtName: item.districtName,
                      address: item.addressFollow,
                      latitude: item.latitude,
                      precisionLng: item.precisionLng,
                })));
              } else {
                this.$message.error('检查网络，或选择所属地域~');
                resolve([]);
              }
            }).catch(err => {
              this.$message.error(err,'检查网络，请联系管理员~');
              reject(new Error('JSONP请求失败'));
            })
        })

    },

    handleClears(itme) {
      console.log('Selected value:', itme);
      this.xxxxx = itme.regionName
      itme.remarks = ''
      itme.detailedAddress = ''
      itme.newaddress = ''
      itme.precisionLng = ''
      itme.city = ''
      itme.latitude = ''
      itme.value = ''
      itme.district = ''
      itme.addressTitleName = ''
      itme.addressFollow = ''
      itme.districtName = ''
      itme.address = ''
    },

    handleAdd(){
      this.ListDataLngLat.push({
        regionName:'',
        newaddress:'',
        detailedAddress:'',
        remarks:'',
        latitude:'',
        city:'',
        value: '',
        city: '',
        district: '',
        addressTitleName: '',
        addressFollow: '',
        districtName: '',
        address: '',
        precisionLng: '',
      })
    },

    handleRemove(){
       this.ListDataLngLat.pop()
    },

    handleClear(event) {
      console.log('Selected value:', event);
      this.remarks = ''
      this.detailedAddress = ''
      this.newaddress = ''
    },

    handleSelect (item) {
      console.log('用户选择了:', item);
      this.infoObj = item
      this.newaddress = item.value; // 确保选中的值绑定到表单中
    },

    handleautocompleteClear(event) {
     this.infoObj = {};
    },

    // 模拟从后端获取搜索结果
    async querySearchAsync(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }

      // 模拟调用后端接口获取数据
      const results = await this.fetchAddressesFromBackend(queryString);

      // 调用回调函数，传递搜索结果
      cb(results);
    },

    // 模拟后端接口请求
    fetchAddressesFromBackend(query) {

        return new Promise((resolve, reject) => {
            let dateObj = {
              regionName: this.regionName === 1 ? '北京' : this.regionName === 2 ? '深圳' : this.regionName === 3 ? '上海' : this.regionName === 4 ? '广州' : '',
              keyword: query
            }
            axios.post(`${apiBaseUrl}/student/getSiteInfoList`, dateObj,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
              if (res.data.code === 200) {
                console.log(res.data.data, '获取地址列表')
                resolve(res.data.data.map(item => ({
                      value: item.addressTitleName,
                      city: item.districtName,
                      district: item.addressFollow,
                      address: item.addressFollow,
                      latitude: item.latitude,
                      precisionLng: item.precisionLng,
                })));
              } else {
                resolve([]);
                this.$message.error(err);
              }
            }).catch(err => {
              this.$message.error(err);
              reject(new Error('JSONP请求失败'));
            })
        })
      



      // return new Promise((resolve, reject) => {
      //     const regionName = this.regionName === 1 ? '北京' : this.regionName === 2 ? '深圳' : this.regionName === 3 ? '上海' : this.regionName === 4 ? '广州' : '';
      //     const apiKey = 'V2CBZ-VZZET-O6SXA-LIJJX-7NZ23-KWBXD';
      //     const callbackName = `jsonpCallback_${Date.now()}`;
      //     const script = document.createElement('script');
      //     script.src = `https://apis.map.qq.com/ws/place/v1/suggestion?keyword=${encodeURIComponent(query)}&region=${regionName}&key=${apiKey}&output=jsonp&callback=${callbackName}`;

      //     window[callbackName] = (data) => {
      //         document.body.removeChild(script);
      //         delete window[callbackName];
      //         if (data.status === 0) {
      //             resolve(data.data.map(item => ({
      //                 value: item.title,
      //                 city: item.city,
      //                 district: item.district,
      //                 address: item.address,
      //                 location: item.location,
      //             })));
      //         } else {
      //             console.error('腾讯地图API错误:', data.message);
      //             resolve([]);
      //         }
      //     };

      //     script.onerror = () => {
      //         document.body.removeChild(script);
      //         delete window[callbackName];
      //         reject(new Error('JSONP请求失败'));
      //     };

      //     document.body.appendChild(script);
      // });
    },

    updatePageNumsss(newPage){

      this.pageNumsss = newPage;
    },

    handleClickView(itme){
      window.sessionStorage.setItem('telephoneCommunication','telephoneCommunication')
      // this.$router.push({path:'/student-detail/' + itme.studentId, query:{ type:'telephoneCommunication' }})

      this.$router.push({path:`/student-detail/${itme.studentId}/${this.fromState.pageNum}`,query:{ type:'telephoneCommunication' } })

    },

    handleView(){
      this.handleInput()
      this.showView = true
    },

    handleCurrentChanges(e){
      this.pageNums = e
      this.handleInput()
    },
    handleSizeChanges(e){
      this.pageSizes = e
      this.handleInput()
    },

    changeRegion(){

      axios.get(`${ apiBaseUrl }/dict/getDictionarySon/${this.editFormData.regionName} `, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ 
          if(res.data.code === 200){
              this.optionsListtt = res.data.data
          }else{
            this.optionsListtt = []
          }
       }).catch((err)=>{
          this.$message({ message: err , type: "error" })
       })
    },

    handleInput(){
      let data = {  pageNum: this.pageNums,  pageSize: this.pageSizes, studentName: this.input1,  }
      axios.post(`${apiBaseUrl}/communication/findStudentPage`, data,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') } }).then(res => {
          if(res.data.code === 200){
              if(res.data.data.records && res.data.data.records.length > 0){
                this.tableData = res.data.data.records
              }else{
                this.tableData = []
              }
              this.pageNums = res.data.data.current
              this.pageSizes = res.data.data.size
              this.totals = res.data.data.total
          }else{
            this.$message.error('error失败~')
          }
      })
    },

    count () {
      axios
        .get(`${apiBaseUrl}/student/calculate`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message)
            this.allStudent();
          } else {
            this.$message.error(res.data.message)
          }
        })
        .catch(error => {
          console.error(error);
        });
    },

    handleDownload1 () {
      this.show_view = true
    },



    handleDownload () {
      const params = {
        classType: this.fromState.classType,
        realname: this.fromState.realname,
        wechat: this.fromState.wechat,
        telephone: this.fromState.telephone,
        address: this.fromState.address,
        progressTeacherName: this.fromState.progressTeacherName,
        sourcepeopleId: this.fromState.sourcepeopleId,
        saleId: this.fromState.saleName,
        gradeList: this.fromState.gradeList,
        state: this.fromState.state,
        assistantId: this.fromState.assistantId,
        createStartTime : this.createTimeStart ? this.createTimeStart : '',
        createEndTime : this.createTimeEnd ? this.createTimeEnd : '',
        regionName : this.fromState.regionName || localStorage.getItem('cityTepy'),
        diagnoseTeacherId:this.fromState.diagnoseTeacherId,
        projectTeacherId:this.fromState.projectTeacherId,

        lapsedDateStart: this.lapsedDateStart ? this.lapsedDateStart + ' 00:00:00' : '',
        lapsedDateEnd: this.lapsedDateEnd ? this.lapsedDateEnd + ' 23:59:59' : '',
      };
      axios
        .post(
          `${apiBaseUrl}/student/exportOfficialStudent`,
          params,
          { responseType: "blob",

          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')

        } } // 设置responseType为'blob'以接收二进制数据
        )
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.ms-excel",
          }); // 从响应中获取Blob对象
          const downloadLink = document.createElement("a"); // 创建一个下载链接
          downloadLink.href = URL.createObjectURL(blob); // 设置下载链接的URL为Blob对象的URL
          downloadLink.download = "学生.xlsx"; // 设置下载文件的文件名
          //

          downloadLink.click(); // 触发下载
        })
        .catch((error) => {

        });
    },
    //获取年级
    getGrade () {
      axios
        .get(`${apiBaseUrl}/grade/getGrade`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.data.length > 0) {
            this.gradeList = res.data.data;
          } else {
            this.$message({
              message: "获取年级列表失败",
              type: "error"
            });
          }
        })
        .catch(error => {

        });
    },
    refresh () {
      this.allStudent();
    },
    //客资来源负责人
    getDataSoursePeople () {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          this.sourcesPeople = response.data.data.list;

        })
        .catch(error => {
          console.error(error);
        });
    },
    //销售
    teacherSale () {
      axios
        .get(`${apiBaseUrl}/teacher/teacherSale`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          this.salesName = response.data.data
          // this.Progressteacher = response.data.data  //跟进老师
          //
          //
          this.Progressteacher1 = response.data.data; //跟进老师
          //
          //
          //
        })
        .catch(error => {
          console.error(error);
        });
    },
    //跟进老师
    getTeacher () {
         axios.get(`${apiBaseUrl}/schedule/assistantList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => {
          // this.salesName = response.data.data
          // this.Progressteacher = response.data.data  //跟进老师
          //
          //
          this.Progressteacher = response.data.data; //跟进老师
          //
          //
          //
        })
        .catch(error => {
          console.error(error);
        });
    },

    //选中学员事件
    handleSelectionChange (arr) {
      const aa = [];
      for (let i = 0; i < arr.length; i++) {
        aa.push(arr[i].id);
      }
      this.teacherId = aa;
    },
    // 清空年级回到查询所有学生
    gradeListener () {
      this.allStudent();
      this.value2 = "";
    },

    // 清空班级回到查询所有班级
    classListener () { },

    // 查询班级信息
    queryClass () {
      this.$axios
        .get(`${apiBaseUrl}/class-grade/` + this.value1,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          let ret = res.data.data;
          this.classNo.splice(0, this.classNo.length);
          this.value2 = "";
          ret.map(v => {
            this.classNo.push({
              value: v.classNo,
              label: v.className
            });
          });
        })
        .catch(error => { });
    },

    cancelUpd () {
      this.visibleForm = false;
      if (this.$refs.editFormData) {
        this.$nextTick(() => {
          this.$refs.editFormData.resetFields();
        });
      }
    },

    cancel () {
      if (this.$refs.editFormData) {
        this.$nextTick(() => {
          this.$refs.editFormData.resetFields();
        });
      }
      this.visibleDialog = false;
      this.$refs.editFormData.clearValidate();
    },
    // 根据班级查询学生信息
    queryStudentByClass () {
      this.$axios
        .get(`${apiBaseUrl}/student-class/` + this.fromState.pageNum + "/" + this.value2,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {

          if (res.data.code == 0) {
            let ret = res.data.data;
            this.studentData = ret.records;
            this.total = ret.total;
          }
        })
        .catch(error => { });
    },

    inputListener () {
      this.allStudent();
    },

     async getallStudentList(){
      let data={
        state:'',
        classType:'',
        realname:'',
        wechat: "",
        gradeList: [],
        telephone: "",
        address: "",
        progressTeacherName: "",
        saleName: "",
        sourcepeopleId: "",
        pageSize: 10,
        pageNum:1,
        assistantId:'',
        regionName : localStorage.getItem('cityTepy')
      }

      if(this.currentPath === '/currentStudents'){
       data.state = 1
        data.isReading = 1
        }

        try {


            const res = await axios.post(`${apiBaseUrl}/student/officialStudent`, data, {
                headers: {
                    'authorization': sessionStorage.getItem('tokenInfo')
                }
            });

            // 更新学生数据和总数
            this.studentData = res.data.data.records;

            this.total = res.data.data.total;
            this.currentPage = res.data.data.current;

            window.sessionStorage.setItem('pages',1)

        } catch (err) {
            console.error("Error fetching student data: ", err);
        }

        // await axios
        // .post(`${apiBaseUrl}/student/students`, this.fromState,{
        //   headers:{
        //     'authorization': sessionStorage.getItem('tokenInfo')
        //   }
        // })
        // .then(res => {
        //   //
        //   this.studentData = res.data.data.records;
        //
        //   //
        //   //
        //   this.total = res.data.data.total;
        //   // this.pageSize = res.data.data.page;
        //   this.currentPage = res.data.data.current;

        // })
        // .catch(err => {
        //   //
        // });
      // }else{
      //  await axios
      //   .post(`${apiBaseUrl}/student/students`, this.fromState,{
      //     headers:{
      //       'authorization': sessionStorage.getItem('tokenInfo')
      //     }
      //   })
      //   .then(res => {
      //     //
      //     this.studentData = res.data.data.records;
      //
      //     //
      //     this.total = res.data.data.total;
      //     // this.pageSize = res.data.data.page;
      //     this.currentPage = res.data.data.current;

      //   })
      //   .catch(err => {
      //     //
      //   });
      // }
    },
    //查询所有学生
    allStudent () {
      // this.handleClearList()

      let data={
        state:this.fromState.state,
        classType:this.fromState.classType,
        realname:this.fromState.realname,
        wechat: this.fromState.wechat,
        gradeList: this.fromState.gradeList,
        telephone: this.fromState.telephone,
        address: this.fromState.address,
        progressTeacherName: this.fromState.progressTeacherName,
        saleId: this.fromState.saleName,
        sourcepeopleId: this.fromState.sourcepeopleId,
        pageSize: this.fromState.pageSize,
        pageNum: this.fromState.pageNum,
        assistantId: this.fromState.assistantId,
        regionName : this.fromState.regionName || localStorage.getItem('cityTepy'),
        createStartTime : this.createTimeStart,
        createEndTime : this.createTimeEnd,
        
        diagnoseTeacherId:this.fromState.diagnoseTeacherId,
        projectTeacherId:this.fromState.projectTeacherId,
        channelType:this.channelType,

        lapsedDateEnd : this.lapsedDateEnd  ? this.lapsedDateEnd + ' 23:59:59' : '',
        lapsedDateStart : this.lapsedDateStart ? this.lapsedDateStart + ' 00:00:00' : '',

      }

      if(this.currentPath === '/currentStudents'){
        data.state = 1
        data.isReading = 1
      }

      axios.post(`${apiBaseUrl}/student/officialStudent`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
                    //
            if(res.data.code === 200){
                this.$message.success(res.data.message);
                this.studentData = res.data.data.records;

                //
                this.total = res.data.data.total;
                // this.pageSize = res.data.data.page;
                this.currentPage = res.data.data.current;

            }else{
              this.studentData = []
              this.$message.error("{ code: -1, data: null, msg: null }");
            }

        })
        .catch(err => {
          //
          this.$message.error(err);
        });

      // if(this.currentPath === '/currentStudents'){
      //    this.fromState.state = 1
      //    this.fromState.isReading = 1
      //    axios.post(`${apiBaseUrl}/student/students`, this.fromState,{
      //     headers:{
      //       'authorization': sessionStorage.getItem('tokenInfo')
      //     }
      //   })
      //   .then(res => {
      //     //
      //     this.studentData = res.data.data.records;

      //     //
      //     this.total = res.data.data.total;
      //     // this.pageSize = res.data.data.page;
      //     this.currentPage = res.data.data.current;

      //   })
      //   .catch(err => {
      //     //
      //   });
      // }else{
      //   axios.post(`${apiBaseUrl}/student/students`, this.fromState,{
      //     headers:{
      //       'authorization': sessionStorage.getItem('tokenInfo')
      //     }
      //   })
      //   .then(res => {
      //     //
      //     this.studentData = res.data.data.records;

      //     //
      //     this.total = res.data.data.total;
      //     // this.pageSize = res.data.data.page;
      //     this.currentPage = res.data.data.current;

      //   })
      //   .catch(err => {
      //     //
      //   });
      // }

    },
    handleClearList () {
      this.createTimeStart = ''
      this.createTimeEnd = ''
      this.channelType = ''

      this.lapsedDateStart = ''
      this.lapsedDateEnd = ''

      this.fromState = {
        realname: "",
        wechat: "",
        gradeList: [],
        classType: '',
        telephone: "",
        address: "",
        progressTeacherName: "",
        saleName: "",
        sourcepeopleId: "",
        pageSize: 10,
        pageNum: 1,
        assistantId:'',
        regionName:''
      }
      this.allStudent()
    },
    //关键字查询学生
    searchStudent () {
      this.fromState.pageNum = 1
      if (this.fromState.progressTeacherName != '' || this.fromState.saleName != '' || this.fromState.sourcepeopleId != '') {
        this.fromState.pageSize = 10
      }
      this.allStudent()
      // this.$axios
      //   .get(`${apiBaseUrl}/student/search/` + this.keyword)
      //   .then(res => {
      //     let ret = res.data.data;
      //
      //     this.studentData = ret.records;
      //
      //     this.total = ret.total;
      //
      //     this.$message({ message: "查询成功", type: "success" });
      //   })
      //   .catch(error => {
      //     this.$message.error("查询失败");
      //   });
    },
    //点击添加按钮
    addStudent () {
      this.showEiet = false
      this.$nextTick(() => {
        this.$refs.editStudents.init();
      });
      // this.visibleDialog = true;
      // //点击按钮表单清空
      // axios
      //   .post(`${apiBaseUrl}/teacher/query`, {
      //     page: "",
      //     limit: "",
      //     realname: this.searchTeachers
      //   })
      //   .then(res => {
      //     this.teacherData = res.data.data.list;
      //   })
      //   .catch(err => {
      //
      //   });
    },
    //按回车搜索姓名查询
    handleSearch () {
      if (this.searchTeachers) {
        //
        this.addStudent();
        // 清空搜索框
        // this.name = "";
      }
    },
    // //点击添加保存学生
    // saveAdd() {
    //   const data = {
    //     realname: this.editFormData.realname,
    //     age: this.editFormData.age,
    //     sex: this.editFormData.sex,
    //     telephone: this.editFormData.telephone,
    //     address: this.editFormData.address,
    //     grade: this.editFormData.grade,
    //     wechat: this.editFormData.wechat,
    //     sourcepeopleId: this.editFormData.sourcepeopleId,
    //     progressTeacherIds: this.editFormData.progressTeacherIds,
    //     saleId: this.editFormData.saleId
    //   };

    //   axios
    //     .post(`${apiBaseUrl}/student/addstudent`, data)
    //     .then(res => {
    //       //
    //       if (res.data.code == 200) {
    //         //成功
    //         this.$message({
    //           message: res.data.message,
    //           type: "success"
    //         });
    //        this.visibleDialog = false;

    //         this.allStudent();
    //       } else {
    //         //失败
    //         this.$message({
    //           message: res.data.message,
    //           type: "error"
    //         });
    //       }
    //     })
    //     .catch(err => {
    //       console.error(err);
    //     });
    // },

    // saveAdd(formName) {
    //   this.$refs['editFormData'].validate(valid => {
    //     if (valid) {
    //       const data = {
    //         realname: this.editFormData.realname,
    //         age: this.editFormData.age,
    //         sex: this.editFormData.sex,
    //         telephone: this.editFormData.telephone,
    //         classNo: this.editFormData.classNo,
    //         address: this.editFormData.address,
    //         grade: this.editFormData.grade,
    //         // teacherId: this.teacherId.join(",")
    //       };

    //       axios
    //         .post(`${apiBaseUrl}/student/addstudent`, data)
    //         .then(res => {
    //           //
    //           if (res.data.code == 200) {
    //             //成功
    //             this.$message({
    //               message: res.data.message,
    //               type: "success"
    //             });
    //             //如表单还有数据没有清空掉就给默认值
    //             // this.$refs.ruleForm.resetFields();
    //             // this.listdate();
    //             this.visibleDialog = false;
    //             this.allStudent();
    //           } else {
    //             //失败
    //             this.$message({
    //               message: res.data.message,
    //               type: "error"
    //             });
    //           }
    //         })
    //         .catch(err => {
    //           console.error(err);
    //         });
    //     } else {
    //       return false;
    //     }
    //   });
    // },

    //根据id删除学生
    deleteById (index, row) {
      this.$confirm('此操作将删除该该学生, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
              this.deleteStudentById(row.id);
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },

    deleteStudentById (id) {
      this.$axios
        .delete(`${apiBaseUrl}/student/delete/` + id,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.$message({ message: "删除成功", type: "success" });
          this.allStudent();
        })
        .catch(error => {
          this.$message.error("删除失败");
        });
    },

    closeEditDialog () {
      this.visibleForm = false;

      this.infoObj = {}
      this.remarks = ''
      this.detailedAddress = ''
      this.newaddress = ''  
      this.regionName = ''
    },

    // 点击编辑学生回显数据
    editById (index, row) {
      this.showEiet = true
      let modifyId = row.id;
      this.$axios
        .get(`${apiBaseUrl}/student/` + modifyId,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {

          // this.regionName = res.data.data.regionName ? res.data.data.regionName : '北京'

          this.editFormData = res.data.data;
          this.isclassType = res.data.data.classType

          this.isLose = res.data.data.isLose ? res.data.data.isLose : 0

          //
          this.editFormData.grades = JSON.parse(res.data.data.grade)
          this.editFormData.sex = res.data.data.sex + "";

          this.editFormData.channelType = res.data.data.channelType

          // this.editFormData.regionName = res.data.data.regionName  ? res.data.data.regionName : '北京'
          this.editFormData.regionName = Number(res.data.data.regionName)
          this.editFormData.diagnoseTeacherId = res.data.data.diagnoseTeacherId ? res.data.data.diagnoseTeacherId : ''
          this.editFormData.projectTeacherId = res.data.data.projectTeacherId ? res.data.data.projectTeacherId : ''

          this.regionName = res.data.data.regionName ? res.data.data.regionName : 1

          this.newaddress = res.data.data.addressTitleName
          this.detailedAddress = res.data.data.addressInfo 
          this.remarks = res.data.data.addressRemark
          
          this.infoObj.value = res.data.data.addressTitleName
          this.infoObj.address = res.data.data.addressFollow
          this.infoObj.district = res.data.data.districtName
          this.infoObj.latitude = res.data.data.latitude
          this.infoObj.precisionLng = res.data.data.precisionLng
          this.infoObj.city = res.data.data.districtName ? res.data.data.districtName : ''


          if (res.data.data.prepareAddress instanceof Array) {
              this.ListDataLngLat = res.data.data && res.data.data.prepareAddress.length > 0 ? res.data.data.prepareAddress : []
          } 


          this.xxxxx = Number(res.data.data.regionName)

          if (res.data.data.prepareAddress){
              this.ListDataLngLat = res.data.data && res.data.data.prepareAddress ? JSON.parse(res.data.data.prepareAddress).map((itmes)=>{
                  itmes.value = itmes.addressTitleName
                  itmes.city = itmes.districtName
                  itmes.district = itmes.addressFollow
                  itmes.addressTitleName = itmes.addressTitleName
                  itmes.addressFollow = itmes.addressFollow
                  itmes.districtName = itmes.districtName
                  itmes.address = itmes.addressFollow
                  itmes.latitude = itmes.latitude
                  itmes.precisionLng = itmes.precisionLng
                  itmes.regionName = this.regionName
                  itmes.detailedAddress = itmes.addressInfo 
                  itmes.remarks = itmes.addressRemark 
                  itmes.newaddress = itmes.addressTitleName

                  return itmes
              }) : []
          }


          // axios.get(`${ apiBaseUrl }/dict/getDictionarySon/${this.editFormData.regionName} `, { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ 
          //         if(res.data.code === 200){
          //             this.optionsListtt = res.data.data
          //         }else{
          //           this.optionsListtt = []
          //         }
          // }).catch((err)=>{
          //         this.$message({ message: err , type: "error" })
          // })

          //
          this.editFormData.districtId = res.data.data.districtId

          if(res.data.data.assistantId){
              this.editFormData.assistantId = res.data.data.assistantId ? res.data.data.assistantId : null
          }


          if (res.data.data.sourcepeopleId == null) {
            this.editFormData.sourcepeopleId = res.data.data.sourceName
          } else {
            this.editFormData.sourcepeopleId = res.data.data.sourcepeopleId
          }
        })
        .catch(error => { });
          this.editFormData = row;
          this.prestoreHoursNum = row.prestore,
          this.eliminateHoursNum = row.eliminate,
          this.arrearsHoursNum = row.arrears,
          this.visibleForm = true;
    },

    //编辑提交
    commit () {
      //
      this.editFormData.sex = this.editFormData.sex;
      if (typeof this.editFormData.sourcepeopleId === 'number') {
        this.editFormData.sourcepeopleId = this.editFormData.sourcepeopleId
        this.editFormData.sourceName = ""
      } else {
        this.editFormData.sourceName = this.editFormData.sourcepeopleId
        this.editFormData.sourcepeopleId = null
      }

      

      if(!this.regionName){
        this.$message({
          message: '请选择所在地域',
          type: 'warning'
        });
        return;
      }
      if(!this.editFormData.realname){
        this.$message({
          message: '请输入姓名',
          type: 'warning'
        });
        return;
      }

      if(!this.editFormData.grades || this.editFormData.grades.length === 0){
        this.$message({
          message: '请选择年级',
          type: 'warning'
        });
        return;
      }

      if(!this.editFormData.sex){
        this.$message({
          message: '请选择性别',
          type: 'warning'
        });
        return;
      }

      if(!this.editFormData.classType){
        this.$message({
          message: '请选择班型',
          type: 'warning'
        });
        return;
      }



      if(this.regionName && this.editFormData.realname && this.editFormData.grades && this.editFormData.sex && this.editFormData.classType){
        this.modifyStudent(this.editFormData);
      }else{
        this.$message({
          message: '请填写必填项',
          type: 'warning'
        });
      }

    },

    // precisionLng;//精度  //地址下拉接口返回
    // latitude;//纬度  //地址下拉接口返回
    // addressTitleName;//地址标题  //地址下拉接口返回
    // addressFollow;//地址详情 //地址下拉接口返回
    // addressInfo;//详情地址 请输入单元 楼层门牌号
    // addressRemark; //地址备注

    //更新学生
    modifyStudent (modifyData) {
      
      let ListDataLngLat = []
      this.ListDataLngLat.map((item)=>{
        let obj = {}

        obj.precisionLng = item.precisionLng ? item.precisionLng : ''
        obj.latitude = item.latitude ? item.latitude : ''
        obj.addressTitleName = item.value ? item.value : ''
        obj.addressFollow = item.address ? item.address : ''
        obj.addressInfo = item.detailedAddress ? item.detailedAddress : ''
        obj.addressRemark = item.remarks ? item.remarks : ''
        obj.districtName = item.city ? item.city : ''
        ListDataLngLat.push(obj)

      })


     modifyData.prepareAddressList = ListDataLngLat

      modifyData.createTime = null;
      modifyData.prestore = this.prestoreHoursNum
      modifyData.eliminate = this.eliminateHoursNum
      modifyData.arrears = this.arrearsHoursNum

      // modifyData.regionName = this.regionName



      modifyData.regionName =  this.regionName ? this.regionName : ''
      modifyData.addressTitleName =  this.infoObj.value ? this.infoObj.value : ''
      modifyData.addressFollow =  this.infoObj.address ? this.infoObj.address : ''
      modifyData.addressInfo =  this.detailedAddress ? this.detailedAddress : ''
      modifyData.addressRemark =  this.remarks ? this.remarks : ''
      modifyData.districtName =  this.infoObj.city ? this.infoObj.city : ''
      modifyData.latitude =  this.infoObj.latitude ? this.infoObj.latitude : ''
      modifyData.precisionLng =  this.infoObj.precisionLng ? this.infoObj.precisionLng : ''


      modifyData.diagnoseTeacherId = this.editFormData.diagnoseTeacherId
      modifyData.projectTeacherId = this.editFormData.projectTeacherId

      modifyData.channelType = this.editFormData.channelType
      modifyData.isLose = this.isLose

      this.$axios
        .post(
          `${apiBaseUrl}/student/modify/` + this.editFormData.id,
          modifyData,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }
        )
        .then(res => {
          //
          if(res.data.code === 200){
            this.$message({ message: res.data.message, type: "success" });
            this.allStudent();
            this.visibleForm = false;
            this.ListDataLngLat = []

            this.infoObj = {}
            this.remarks = ''
            this.detailedAddress = ''
            this.newaddress = ''  
            this.regionName = ''
            
          }else{
            this.$message({ message: res.data.message, type: "warning" });
          }
        })
        .catch(error => {
          this.$message.error("更新失败");
        });
    },

    handleSizeChange (val) {

    },

    handleCurrentChange (v) {


      this.fromState.pageNum = v;
      this.allStudent();
    },
    //点击姓名出现弹层
    highlightRow (id,index) {
      window.sessionStorage.setItem('telephoneCommunication','classPlan')

      this.$router.push({path:`/student-detail/${id}/${this.fromState.pageNum}`, })


      // 清除之前的高亮状态
      if (this.highlightedIndex !== -1) {
        // 假设表格组件提供了清除高亮的方法，如 clearHighlight
        // this.$refs.table.clearHighlight();
      }
      // 设置当前行为高亮状态
      // 假设表格组件提供了设置高亮的方法，如 highlightRow
      // this.$refs.table.highlightRow(index);
      this.highlightedIndex = index;

    }
  }

};
</script>

<style scoped>
.el-input-group {
  width: 40%;
}

.header-menu {
  margin-bottom: 5px;
  padding: 0;
  text-align: left;
  margin-bottom: 5px;
}

.footer-button {
  margin-top: 10px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */
  #bb>>>.el-dialog {
    width: 70%;
  }

  .el-input-group {
    width: 60%;
  }

  .sex {
    margin-left: -15% !important;
  }
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}



</style>



// WEBPACK FOOTER //
// src/EnrolledStudent/EnrolledStudent.vue